const getTenantIdFromURL = () => {
    // Read from pathname so query strings and hashes never become part of the
    // tenant identifier (for example `tenant-id?view=atrisk`). Locate the route
    // segment by name instead of relying on the origin-dependent array index.
    const parts = window.location.pathname.split('/').filter(Boolean);
    const tenantRouteIndex = parts.indexOf('tenant-dashboard');

    if (tenantRouteIndex === -1 || !parts[tenantRouteIndex + 1]) return undefined;

    return decodeURIComponent(parts[tenantRouteIndex + 1]);
};

export default getTenantIdFromURL;
